import { Dexie } from 'dexie';  

export class AppDatabase extends Dexie 
{
    enduserkv!: Dexie.Table<EndUserStore, number>;

    constructor() 
    {  
      super("EndUserDatabase");
      
      this.version(1).stores({
        enduserkv: '',
      });
    }
}

export interface EndUserStore {
    ExipryDate: string; 
    RefreshToken: string; 
    RememberMe: string,
    Role: string,
    Token: string,
}